<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            width="60%"
        >
            <div class="banner-title" v-html="bannerData.title"></div>
            <div class="banner-content" v-html="bannerData.content"></div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    :type="bannerData.buttonType"
                    @click="dialogVisible = false"
                    >Ok</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'banner',
    async mounted() {
        await this.getFileFromS3();
    },
    methods: {
        async getFileFromS3() {
            const fileUrl = process.env.VUE_APP_BANNER_FILE_URL;
            try {
                const response = await axios.get(fileUrl);
                const data = response.data;
                this.bannerData = data || {};
                this.bannerData.buttonType = data.buttonType || 'danger';
                this.validateDialogToShow(this.bannerData);
            } catch (error) {
                console.log('banner file error', error);
            }
        },
        validateDialogToShow(data) {
            if (data.title || data.content) {
                const localStorageVersion = localStorage.getItem('bannerVer');
                if (data.version != localStorageVersion || data.show != 'once') {
                    this.showDialog(data.version);
                }
            }
        },
        showDialog(ver) {
            this.dialogVisible = true;
            localStorage.setItem('bannerVer', ver);
        },
    },
    data: function() {
        return {
            dialogVisible: false,
            bannerData: {},
        };
    },
};
</script>

<style scoped>
.banner-title {
    font-weight: bold;
    font-size: 22px;
}
.banner-content {
    font-size: 18px;
    padding: 20px 0;
    font-weight: 400;
    text-align: left;
}
>>>div.el-dialog__body {
    word-break: break-word;
}
</style>
